export default "__VITE_ASSET__jMUsHaY2__"